let w = window.innerWidth;
if (w < 992) {
    var swiper = new Swiper('.image-text-slider', {
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
            el: ".image-text-pagination",
            clickable: true
        }
    }); 
}